const BEARER_PREFIX = 'Bearer ';

function headersFromInit(init?: RequestInit): Headers {
  if (init instanceof Request) {
    return new Headers(init.headers);
  }
  return new Headers(init?.headers);
}

/**
 * Returns a shallow clone of `init` with `Authorization: Bearer <token>`
 * merged in. A caller-supplied Authorization header wins.
 */
export function withAuthHeader(
  init: RequestInit | Request | undefined,
  token: string
): RequestInit {
  const headers = headersFromInit(init);

  if (!headers.has('Authorization')) {
    headers.set('Authorization', `${BEARER_PREFIX}${token}`);
  }

  if (init instanceof Request) {
    return { ...init, headers };
  }

  return { ...(init ?? {}), headers };
}
